<div class="modal-container">
  <h2 class="modal-title">Update Personal Information</h2>
  <form [formGroup]="personalInfoForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-field">
        <label for="name">Name</label>
        <input
          pInputText
          id="name"
          type="text"
          formControlName="name"
          class="w-full"
        />
        <small
          class="error-message"
          *ngIf="
            personalInfoForm.get('name')?.invalid &&
            personalInfoForm.get('name')?.touched
          "
        >
          Name is required
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label for="mobile_number">Mobile Number</label>
        <input
          pInputText
          id="mobile_number"
          type="text"
          formControlName="mobile_number"
          class="w-full"
        />
        <small
          class="error-message"
          *ngIf="
            personalInfoForm.get('mobile_number')?.invalid &&
            personalInfoForm.get('mobile_number')?.touched
          "
        >
          Enter a valid 10-digit mobile number
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label for="gender">Gender</label>
        <p-dropdown
          id="gender"
          formControlName="gender"
          [options]="[
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
            { label: 'Other', value: 'Other' }
          ]"
          placeholder="Select a gender"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
        ></p-dropdown>
        <small
          class="error-message"
          *ngIf="
            personalInfoForm.get('gender')?.invalid &&
            personalInfoForm.get('gender')?.touched
          "
        >
          Gender is required
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label for="dob">Date of Birth</label>
        <p-calendar
          id="dob"
          formControlName="dob"
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          styleClass="w-full"
        ></p-calendar>
        <small
          class="error-message"
          *ngIf="
            personalInfoForm.get('dob')?.invalid &&
            personalInfoForm.get('dob')?.touched
          "
        >
          Date of Birth is required
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <label for="aadhaar">Aadhaar Number</label>
        <input
          pInputText
          id="aadhaar"
          type="text"
          formControlName="aadhaar"
          class="w-full"
        />
        <small
          class="error-message"
          *ngIf="
            personalInfoForm.get('aadhaar')?.invalid &&
            personalInfoForm.get('aadhaar')?.touched
          "
        >
          Enter a valid 12-digit Aadhaar number
        </small>
      </div>
    </div>

    <div class="form-actions">
      <button
        pButton
        label="Cancel"
        class="p-button-secondary"
        type="button"
        (click)="onCancel()"
        [disabled]="loading"
      ></button>
      <button
        pButton
        label="Update"
        type="submit"
        [disabled]="personalInfoForm.invalid || loading"
        [loading]="loading"
      ></button>
    </div>
  </form>
</div>
